module.exports = __webpack_public_path__ + "static/img/logo.029b75c1.svg";